import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { centerClient } from "../shared/clients";

interface IInformationDialogProps {
    visible: boolean;
    setVisible: Dispatch<SetStateAction<boolean>>;
}
export const InformationDialog = (props: IInformationDialogProps) => {
    const { visible, setVisible } = props;
    const [backendVersion, setBackendVersion] = useState('1.0.0');
    const handleClose = () => {
        setVisible(false);
    }
    const getBackendVersion = () => {
        centerClient.getBackendVersion()
            .then((res) => {
                const data = res.data;
                if (data)
                    setBackendVersion(data);
            })
            .catch(() => void 0);
    }
    useEffect(() => {
        if (visible)
            getBackendVersion();
    }, [visible])
    return (
        <Modal id="editCommentContainer" show={visible} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Информация</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <label>Версия JS - {__APP_VERSION__}</label>
                    <label>Версия CenterWeb - {backendVersion}</label>
                </div>
            </Modal.Body>
        </Modal>    
    )
}